var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('drawer',{attrs:{"name":_vm.DRAWERS.MODULE_FORM}},[_c('module-form-drawer')],1),_c('router-view',{key:((_vm.$route.params.slug) + "-" + (_vm.$route.name))})],1)}
var staticRenderFns = []

export { render, staticRenderFns }